<template>
  <div class="mt-20">
    <h5 class="text-bold">Adjust T Shirt Configuration</h5>
    <div class="row">

      <div id="fabric-id-input" class="col-md-12 mt-20">
        <label>Fabric</label>
        <v-select
          class="select-fabric"
          :options="fabrics"
          v-model="productOrder.configuration.special_fabric"
          label="production_name"
          :reduce="(fabrics) => fabrics.id"
          placeholder="Select Fabric" />

        <small v-if="errors.special_fabric" class="text-danger">Required Fabric</small>

      </div>

      <div id="cuff-type-id-input" class="col-md-12 mt-20">
        <label>Size</label>
        <v-select
          class="select-size"
          :options="sizes"
          v-model="productOrder.configuration.size"
          placeholder="Select Size"
        />
        <small v-if="errors.size" class="text-danger"
          >Required Size</small
        >
      </div>

      <div class="col-md-12 mt-20">
        <button class="btn btn-primary btn-block" @click="updateTshirt">
          Update T Shirt
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["productOrder"],

  data() {
    return {
      fabrics: [],
      sizes: [],
      errors: {},
    };
  },

  mounted() {
    this.fabrics = ['White', 'Black', 'Green', 'Beige', 'Lila'];
    this.sizes = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  },

  methods: {

    async updateTshirt() {
      try {
          this.errors = {};
          let res = await axios.post(`product_orders/update-order-configuration/${this.productOrder.id}`, this.productOrder.configuration);
          if (res) {
            toastr.success("Successfully Updated");
          }
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },

  },
};
</script>
